import axios from 'axios';
import Jsona from 'jsona';
import store from '../../store';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function getQueueCheck(profile_id, options) {
  let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
  let checkURL = `${url}/queue/check/`+profile_id+`?session_id=`+currentSession;
  let statusData = null;
  await axios.get(checkURL, {}, options)
  .then((res) => {
    statusData = res;
  }).catch((err) => {
    //console.log("ERROR!@");
    throw new Error(err.stack);
  });

  return statusData;
}

async function getProfile(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  if(false) {
    return axios
      .post(`${url}/user/profile/if`, data, options)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          let errorInfo = '';
          for (const [key, value] of Object.entries(res.data)) {
            errorInfo += `<br> ${key}: ${value} <br>`;
          }
          errorInfo += `<br> API LINK: ${url}/user/profile/ife <br>`;
          throw new Error(errorInfo);
        }
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.stack);
      });
  } else {
    let statusData = null;
    let keepRunning = true;

    //console.log(store._modules.root._children.user.state.user); //


    let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
    await axios
      .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + data.profile_id, {
        params: {session_id: currentSession},
      })
      .then((res) => {}
    );

    let totalTime = 0;
    let interval = 10000; // 10s timestep to avoid spamming the endpoint.

    while((statusData == null || statusData.data.finished == false) && keepRunning) {
      if(totalTime >= 600000) { throw new Error("Queue load timed out!"); break; } // 600s timeout (10min)
      if(statusData) { sleep(interval).then(() => {}); }
      totalTime += 1;
      statusData = await getQueueCheck(data.profile_id, options);
      if(statusData.data.data != null) { break; }
    }

    if(statusData.data.error) {
      //console.log("ERROR!!!");
      throw new Error(statusData.data.errorCode);
    }

    let returnData = null;
    //statusData.data.data = statusData.data.data.replaceAll("\\\\", "");
    //console.log("Status DATA post replace: ", statusData.data.data);
    try {
      returnData = JSON.parse(JSON.parse(statusData.data.data));
    } catch (e) {
      //console.error(e); // error in the above string (in this case, yes)!
      //console.log(statusData.data.data);
    }
    
    //console.log("RETURN DATA: ", returnData);
    //console.log("Status DATA: ", statusData);
    //console.log("RETURN DATA prop: ", returnData.data);

    return returnData;
  }
}

async function getIndustryProfile(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  let userID = localStorage.getItem("queueUserID");
  //console.log(userID);
  if(/*true || userID != 372679*/ false) {
    return axios
      .post(`${url}/user/profile/imr`, data, options)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          let errorInfo = '';
          for (const [key, value] of Object.entries(res.data)) {
            errorInfo += `<br> ${key}: ${value} <br>`;
          }
          errorInfo += `<br> API LINK: ${url}/user/profile/imr <br>`;
          throw new Error(errorInfo);
        }
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.stack);
      });
  } else {
    let statusData = null;
    let keepRunning = true;

    //console.log(store._modules.root._children.user.state.user); //


    let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
    await axios
      .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + data.profile_id, {
        params: {session_id: currentSession},
      })
      .then((res) => {}
    );

    let totalTime = 0;
    let interval = 10000; // 10s timestep to avoid spamming the endpoint.

    while((statusData == null || statusData.data.finished == false) && keepRunning) {
      if(totalTime >= 600000) { throw new Error("Queue load timed out!"); break; } // 600s timeout (10min)
      if(statusData) { sleep(interval).then(() => {}); }
      totalTime += 1;
      statusData = await getQueueCheck(data.profile_id, options);
      if(statusData.data.data != null) { break; }
    }

    if(statusData.data.error) {
      //console.log("ERROR!!!");
      throw new Error(statusData.data.errorCode);
    }

    let returnData = null;
    //statusData.data.data = statusData.data.data.replaceAll("\\\\", "");
    //console.log("Status DATA post replace: ", statusData.data.data);
    try {
      returnData = JSON.parse(JSON.parse(statusData.data.data));
    } catch (e) {
      //console.error(e); // error in the above string (in this case, yes)!
      //console.log(statusData.data.data);
    }
    
    //console.log("RETURN DATA: ", returnData);
    //console.log("Status DATA: ", statusData);
    //console.log("RETURN DATA prop: ", returnData.data);

    return returnData;
  }
}

function getReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/if`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: {url}/user/report/if <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getMarketReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/imr`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/imr <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function saveReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/save`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/save <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}
function getVestimateReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/valuation`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/valuation <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getCompanyReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/company`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/valuation <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

export default {
  getProfile,
  getIndustryProfile,
  getReport,
  getMarketReport,
  getVestimateReport,
  getCompanyReport,
  saveReport,
};
